import React from 'react';
import './style.scss';

export default function SearchBar({
  value,
  onChange,
  placeholder = 'Search events...',
  ...props
}) {
  return (
    <div className="search-bar-wrap-purchase">
      <div className="search-input-container-purchase">
        <svg
          className="search-icon"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        <input
          type="text"
          className="search-input"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          {...props}
        />
      </div>
    </div>
  );
}
